export default __webpack_public_path__ + "images/R8.27b6cba.png";